import dayjs from "dayjs"
import { gender as g } from "keys"
import { isObject, map, pick } from "lodash"

class TestTaker {
    constructor(testTaker, user_type) {
        const {
            learningUnit,
            learningUnitType,

            home_affiliation,
            home_grade,
            home_class,
            learning_group,

            serial_number_row_file, parent_first_name, parent_last_name, parent_phone, parent_email, school_class, language, test_taker_id, school, grade, group, affiliation, first_name, tz, last_name, dob, address, gender } = testTaker

        this.first_name = first_name
        this.test_taker_id = test_taker_id
        this.serial_number_row_file = serial_number_row_file
        this.last_name = last_name
        if (dob)
            this.dob = dayjs(dob).format('YYYY-MM-DD')
        this.address = address
        this.gender = gender?.id || gender || g.female
        this.languages = language ? [language?.id || language] : null
        this.tz = tz

        this.group = group?.id


        // פרטים משותפים לכיתת האם וליישות בית ספר
        this.home_grade = home_grade?.id || home_grade
        this.home_class = home_class?.name || home_class

        if (home_affiliation)
            if (home_affiliation?.institution_code && home_affiliation?.name)
                this.home_affiliation = pick(home_affiliation, ["institution_code", "name"])
            else this.home_affiliation = home_affiliation?.id || home_affiliation

        // אם מדובר בכיתה לא בית ספרית
        if (learningUnitType == 'learning_unit') {
            this.learning_group = learning_group?.id || learning_group
        }

        if (user_type === 'parent')
            this.school_class = school_class?.name

        this.parent_email = parent_email
        this.parent_phone = parent_phone
        this.parent_first_name = parent_first_name
        this.parent_last_name = parent_last_name

        // אם מדובר בשיוך לא בית ספרי, אנחנו נעביר את המזהה קבוצת הלמידה, אם מדובר בשיוך בית ספרי אנחנו מתבססים על פרטי כיתת האם המועברים בכל אופן לשרת
        if (learningUnit && learningUnitType == 'learning_group')
            this.learning_group_id = learningUnit.id
    }
}

export default TestTaker